export default function HomeView({ style, active }) {
    return <div className="sig-home" inert={!active} aria-hidden={!active} style={style}>
        <div className="sig-home-content">
            <p className="sig-hero-copy">I’m an Electrical Engineering graduate from <a className="sig-inline-link" href="https://www.ui.ac.id" target="_blank" rel="noopener noreferrer">Universitas Indonesia</a>, passionate about building systems that connect hardware, software, and intelligent control. <br/><br/> My work spans control systems, embedded development, automation, energy technology, and software engineering, turning engineering ideas into practical solutions.</p>
            <div className="sig-home-actions">
                <a className="sig-primary-action" href="/projects">View projects <span aria-hidden="true">→</span></a>
                <a className="sig-link" href="/resume.pdf" target="_blank" rel="noopener noreferrer">Résumé <span aria-hidden="true">↗</span></a>
            </div>
        </div>
    </div>;
}
